export default {
	namespaced: true,
	state: {
		breadcrumb: [],
		sidebar: true,
		sidebar_content: undefined
	},
	getters: {
		breadcrumb: state => state.breadcrumb,
		sidebar: state => state.sidebar,
		sidebar_content: state => state.sidebar_content
	},
	mutations: {
		mutate(state, payload) {
			state[payload.element] = payload.value
		},
		TOGGLE_SIDEBAR(state, payload) {
			state.sidebar = payload
		},
		SIDEBAR_CONTENT(state, payload) {


			var urlRegex = /(https?:\/\/[^\s]+)/g;
			var wiki = payload.replace(urlRegex, function(url) {
				return '<a target="_blank" href="' + url + '">' + url + '</a>';
			})

			state.sidebar_content = wiki
		}
	},

	actions: {
		doMutate({ commit }, payload) {
			commit("mutate", payload)
		}
	}
}
